module.exports = __webpack_public_path__ + "static/favicon128-65d23744fec29254fde8c6cb2099023c.png";